module.exports = __webpack_public_path__ + "img/usa.c3eae12a.png";